import React from 'react';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen flex items-center justify-center overflow-hidden" data-id="element-95">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-96">
        <img src="https://images.unsplash.com/photo-1503376780353-7e6692767b70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Porsche on track" className="w-full h-full object-cover" data-id="element-97" />
        <div className="absolute inset-0 bg-black bg-opacity-60" data-id="element-98"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10 text-white text-center md:text-left md:max-w-3xl md:ml-16" data-id="element-99">
        <div className="space-y-4" data-id="element-100">
          <h2 className="text-red-500 font-bold text-xl md:text-2xl tracking-wider" data-id="element-101">
            EXCLUSIVE EVENT
          </h2>
          <h1 className="text-4xl md:text-6xl font-bold leading-tight" data-id="element-102">
            Commerce CFO Roundtable 2025
          </h1>
          <p className="text-xl md:text-2xl font-light max-w-2xl" data-id="element-103">
            Join fellow 8 and 9 figure brand and fractional CFOs for insights on
            AI in finance, 2026 planning, and an exhilarating Porsche racing
            experience.
          </p>
          <div className="flex flex-col md:flex-row gap-6 mt-8" data-id="element-104">
            <div className="flex items-center gap-2" data-id="element-105">
              <Calendar className="text-red-500" size={20} data-id="element-106" />
              <span data-id="element-107">November 18, 2025</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-108">
              <MapPin className="text-red-500" size={20} data-id="element-109" />
              <span data-id="element-110">Porsche Experience Center, Los Angeles</span>
            </div>
          </div>
          <div className="pt-8" data-id="element-111">
            <p className="text-red-400 font-semibold mb-3" data-id="element-112">
              Only 2 seats remaining
            </p>
            <a href="#register" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-medium px-6 py-3 rounded-md transition-colors" data-id="element-113">
              Reserve Your Seat
              <ArrowRight size={18} data-id="element-114" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}